import React from "react";

/**
 * StatCard for dashboard summary tiles
 * Props: title, value, icon, change, changeType, color
 */
export default function StatCard({
  title,
  value,
  icon,
  change,
  changeType = "positive", // "positive" | "negative" | "neutral"
  color = "primary",
}) {
  const colorMap = {
    primary: "bg-primary-50 text-primary-600",
    success: "bg-green-50 text-green-600",
    warning: "bg-yellow-50 text-yellow-600",
    danger: "bg-red-50 text-red-600",
    purple: "bg-purple-50 text-purple-600",
    teal: "bg-teal-50 text-teal-600",
  };

  const changeColor = {
    positive: "text-green-600",
    negative: "text-red-600",
    neutral: "text-slate-500",
  };

  return (
    <div className="card flex items-start gap-4">
      {icon && (
        <div
          className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${
            colorMap[color] || colorMap.primary
          }`}
        >
          <span className="text-xl">{icon}</span>
        </div>
      )}
      <div className="flex-1 min-w-0">
        <p className="text-sm text-slate-500 font-medium">{title}</p>
        <p className="text-2xl font-display font-bold text-slate-900 mt-0.5">
          {value}
        </p>
        {change !== undefined && (
          <p className={`text-xs mt-1 ${changeColor[changeType]}`}>{change}</p>
        )}
      </div>
    </div>
  );
}
